import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Alert from '@mui/material/Alert';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

export function TechDocsSubHeader() {
  return (
    <Box paddingBottom={2}>
      <Alert severity="info" variant="outlined">
        <Typography variant="body2" color="text.secondary">
          Want to add your own documentation? Check out how to do this in the{' '}
          <Link href="/docs/default/component/documentation-golden-path">
            Documentation Golden Path
            <ArrowForwardIcon
              sx={{
                height: '1rem',
                width: '1rem',
                verticalAlign: 'text-bottom',
              }}
            />
          </Link>
        </Typography>
      </Alert>
    </Box>
  );
}
